export default __webpack_public_path__ + "static/media/app_logo.e0afd4e0.png";